'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);

var TableContext = React.createContext({ data: { data: [] }, methods: {}, version: 1 });
var TableProvider = TableContext.Provider;

var useTableContext = function () { return (React.useContext(TableContext)); };

exports.TableProvider = TableProvider;
exports.useTableContext = useTableContext;
